import { render, staticRenderFns } from "./input.vue?vue&type=template&id=07b8a8b0&scoped=true&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"
import style0 from "./input.vue?vue&type=style&index=0&id=07b8a8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8a8b0",
  null
  
)

export default component.exports